import { gql } from '@apollo/client'

export const SIGNUP = gql`
  mutation signUp($input: CreateUserInput!) {
    signUp(input: $input) {
      token
      user {
        id
        name
        email
      }
    }
  }
`

export const SIGNIN = gql`
  mutation SignIn($input: LoginUserInput!) {
    signIn(input: $input) {
      status
      message
      data {
        token
        user {
          id
          name
          email
          status
          emailVerified
          department
          designation
          UserRole {
            roleId
            createdBy
            updatedBy
            userId
          }
          franchiseId
        }
      }
    }
  }
`

export const SEND_INVITATION = gql`
  mutation SendInvite($input: SendInviteInput!) {
    sendInvite(input: $input) {
      status
      message
      data
    }
  }
`

export const ACCEPT_INVITATION = gql`
  mutation AcceptInvite($input: AcceptInviteInput!) {
    acceptInvite(input: $input) {
      token
      user {
        id
        name
        email
        status
        Team {
          id
          name
          description
          modifiedAt
          createdAt
        }
      }
    }
  }
`

export const RESEND_INVITATION = gql`
  mutation ResendInvite($input: resendInvitationInput!) {
    resendInvite(input: $input) {
      status
      message
      data
    }
  }
`

export const CANCEL_INVITATION = gql`
  mutation CancelInvite($input: CancelInviteInput!) {
    cancelInvite(input: $input) {
      status
      message
      data
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      status
      message
      data
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_CHATROOM_META_BY_ID = gql`
  mutation UpdateChatRoomMetaById($input: UpdateChatRoomMetaByIdInput!) {
    updateChatRoomMetaById(input: $input) {
      id
    }
  }
`

export const CREATE_CHATROOM_META = gql`
  mutation CreateChatRoomMeta($input: CreateChatRoomMetaByIdInput!) {
    createChatRoomMeta(input: $input) {
      id
    }
  }
`

export const DELETE_CHATROOM_META = gql`
  mutation DeleteChatRoomMeta($input: ChatroomMetaDeletePayload!) {
    deleteChatRoomMeta(input: $input) {
      id
    }
  }
`

export const CREATE_TEAM = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      status
      message
      data
    }
  }
`

export const ADD_USERS_TO_TEAM = gql`
  mutation AddUsersToTeam($input: AddUsersToTeamInput!) {
    addUsersToTeam(input: $input) {
      status
      message
      data
    }
  }
`

export const REMOVE_USERS_FROM_TEAM = gql`
  mutation RemoveUserFromTeam($input: RemoveUserFromTeam!) {
    removeUserFromTeam(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_APPLICATION = gql`
  mutation CreateApplication($input: ApplicationInput!) {
    createApplication(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_BG_ACCOUNT = gql`
  mutation UpdateBgAccount($input: UpdateBgAccountInput) {
    updateBgAccount(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      status
      message
      data
    }
  }
`
export const FORGET_PASSWORD = gql`
  mutation ForgetPassword($input: ForgetPasswordInput!) {
    forgetPassword(input: $input) {
      status
      message
      data
    }
  }
`
export const RESET_PASSWORD = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      status
      message
      data
    }
  }
`

export const ALL_APPLICATION_CONFIG_INPUT = gql`
  mutation UpdateApplicationConfig($input: ApplicationConfigInput!) {
    updateApplicationConfig(input: $input) {
      status
      message
      data
    }
  }
`

export const ALL_APPLICATION_INPUT_JSON = gql`
  mutation UpdateApplicationInput($input: ApplicationInputJson!) {
    updateApplicationInput(input: $input) {
      status
      message
      data
    }
  }
`

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($input: verifyEmailInput) {
    verifyEmail(input: $input) {
      status
      message
      data
    }
  }
`

export const RESEND_OTP = gql`
  mutation ResendOtp($input: ForgetPasswordInput) {
    resendOtp(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_BOT_NAME_BY_ID = gql`
  mutation UpdateBotNameById($input: UpdateBotInput!) {
    updateBotNameById(input: $input) {
      data
      message
      status
    }
  }
`

export const UPDATE_APPLICATION_INPUT = gql`
  mutation UpdateApplicationInput($input: ApplicationInputJson!) {
    updateApplicationInput(input: $input) {
      status
      message
      data
    }
  }
`

export const DELETE_BOT_BY_APPID = gql`
  mutation DeleteApplicationById($input: DeleteApplicationInput!) {
    deleteApplicationById(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_BG_ACCOUNT_BY_SALES = gql`
  mutation CreateBgAccountBySales($input: CreateProfileInput!) {
    createBgAccountBySales(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_BG_ACCOUNT_BY_SALES = gql`
  mutation UpdateBgAccountBySales($input: UpdateBgAccountByRoleInput) {
    updateBgAccountBySales(input: $input) {
      status
      message
      data
    }
  }
`

export const SEND_SET_PASSWORD_MAIL_TO_BG_ACCOUNT_ADMIN = gql`
  mutation SendSetPasswordMailtoBgAccountAdmin($input: sendEmailtoBgAccountAdminInput!) {
    sendSetPasswordMailtoBgAccountAdmin(input: $input) {
      status
      message
      data
    }
  }
`

export const SEND_SET_PASSWORD_MAIL_TO_FRANCHISE_ADMIN = gql`
  mutation SendSetPasswordMailtoFranchiseAdmin($input: sendEmailtoBgAccountAdminInput!) {
    sendSetPasswordMailtoFranchiseAdmin(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_PLAN_DETAILS_BY_BG_ACCOUNT_ID = gql`
  mutation UpdatePlanDetailsByBgAccountId($input: UpdatePlanDetailsInputType!) {
    updatePlanDetailsByBgAccountId(input: $input) {
      data
      message
      status
    }
  }
`

export const UPDATE_FEATURE_LIST_BY_BG_ACCOUNT_ID = gql`
  mutation UpdateFeaturesListByBgAccountId($input: updateFeaturesListInputType!) {
    updateFeaturesListByBgAccountId(input: $input) {
      data
      message
      status
    }
  }
`
export const CREATE_FORM_BUILDER = gql`
  mutation CreateFormBuilder($input: CreateFormBulderInput!) {
    createFormBuilder(input: $input) {
      message
      formUuid
    }
  }
`
export const DELETE_FORM_BUILDER_BY_FORM_ID = gql`
  mutation DeleteFormBuilderByFormId($input: deleteFormBuilderByFormIdInput!) {
    deleteFormBuilderByFormId(input: $input) {
      message
    }
  }
`
export const UPDATE_FORM_BUILDER_BY_FORM_STRING_ID = gql`
  mutation UpdateFormBuilderByFormStringId($input: updateFormBulderInput!) {
    updateFormBuilderByFormStringId(input: $input) {
      message
    }
  }
`
export const CreateFranchiseAccount = gql`
  mutation CreateFranchiseAccount($input: CreateProfileInput!) {
    createFranchiseAccount(input: $input) {
      status
      message
      data
    }
  }
`

export const UpdateFranchiseAccount = gql`
  mutation UpdateFranchiseAccount($input: UpdateFranchiseInput) {
    updateFranchiseAccount(input: $input) {
      status
      message
      data
    }
  }
`
export const ApproveAgreement = gql`
  mutation ApproveAgreement($input: ApproveAgreementInput!) {
    approveAgreement(input: $input) {
      status
      message
      data
    }
  }
`

export const DELETE_APPLICATION_INTENT = gql`
  mutation DeleteApplicationIntent($input: DeleteIntentInputJson!) {
    deleteApplicationIntent(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_PACKAGE_FOR_BY_ACCOUNT_INPUT = gql`
  mutation UpdatePackageForbgAccount($input: updatePackageForBgAccountInput) {
    updatePackageForbgAccount(input: $input) {
      message
    }
  }
`

export const DELETE_TEAM = gql`
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_TEAM = gql`
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_PACKAGE_TYPE = gql`
  mutation CreatePackageType($input: createPackageTypeInputType) {
    createPackageType(input: $input) {
      typeId
      typeName
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`

export const CREATE_PACKAGE = gql`
  mutation CreatePackage($input: createPackageInputType) {
    createPackage(input: $input) {
      packageId
      packageName
      packageDescriptions
      packageAmount
      packageCategory
      packageTypeId
      packageDuration
      packageExpiryDate
      permissions
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`

export const CREATE_FEATURES = gql`
  mutation CreateFeatures($input: createFeatureInputType) {
    createFeatures(input: $input) {
      featuresId
      numberOfBots
      dashboardAccess
      sessionsLimit
      uniqueEndUsers
      additionalConversationCost
      supportUsers
      reportingAnalytics
      language
      CRMIntegration
      additionalChannelntegration
      Intents
      paymentIntegration
      mapIntegraionAPI
      dataSecurity
      conversationHistory
      thirdPartyIntegration
      callToAction
      exportsLeads
      exportReport
      templateCustomization
      emailAndCallSupport
      leadGenerationForm
      multipleChatWindowsForLive_ChatPerUser
      ticketHistory
      blockUser
      visitorInsight
      preDefinedResponses
      liveChat
      whiteLabelRemoveBranding
      fileUploads
      additionalIntegrationPerWebsiteSameBot
      askingPrice
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`

export const CREATE_PACKAGE_FEATURE = gql`
  mutation CreatePackageFeature($input: createPackageFeatureInputType) {
    createPackageFeature(input: $input) {
      featuresId
      packageFeatureId
      packageId
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`
export const CREATE_ROLE = gql`
  mutation CreateRole($input: createRoleInputType) {
    createRole(input: $input) {
      roleId
      roleName
      isPhiAccess
      createdBy
      createdAt
    }
  }
`

export const UPDATE_ROLES_BY_SUPERADMIN = gql`
  mutation UpdateRolesBySuperadmin($input: updateRolesInputType) {
    updateRolesBySuperadmin(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_PERMISSION_BY_ROLE = gql`
  mutation UpdatePermissionByRole($input: updatePermissionByRoleMutationInput) {
    updatePermissionByRole(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_PERMISSION_FOR_ROLE = gql`
  mutation CreatePermissionForRole($input: createPermissionForRoleMutationInput) {
    createPermissionForRole(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_FEATURES = gql`
  mutation UpdateFeatures($input: updateFeatureInputType) {
    updateFeatures(input: $input) {
      status
      message
      data
    }
  }
`

export const ADD_NEW_FEATURES_TO_ALL_ROLES = gql`
  mutation AddNewFeaturesToAllRoles($input: addNewFeaturesToAllRolesMutationInput) {
    addNewFeaturesToAllRoles(input: $input) {
      status
      message
      data
    }
  }
`
export const UPDATE_API_IN_FEATURE = gql`
  mutation UpdateApiInFeature($input: updateApiInFeatureMutationInput) {
    updateApiInFeature(input: $input) {
      status
      message
      data
    }
  }
`
export const PAYMENT_GATEWAY_TO_UPDATE_PLAN = gql`
  mutation PaymentGatewayToUpdatePlan($input: paymentGatewayToUpdatePlanMutationInput) {
    paymentGatewayToUpdatePlan(input: $input) {
      invoiceNumber
    }
  }
`
export const UPDATE_PLAN_FOR_BG_ACCOUNT = gql`
  mutation UpdatePlanForbgAccount($input: updatePlanForBgAccountInput) {
    updatePlanForbgAccount(input: $input) {
      status
      message
      data
    }
  }
`

export const DOWNLOAD_PDF = gql`
  mutation DownloadPdf($input: downloadPdfInputType) {
    downloadPdf(input: $input) {
      pdfLocation
    }
  }
`
export const UPDATE_PDF_LOCATION = gql`
  mutation UpdatePdfLocation($input: updatePdfLocationInputType) {
    updatePdfLocation(input: $input) {
      status
      message
      data
    }
  }
`
export const PAYMENT_GATEWAY_TO_CREATE_PLAN = gql`
  mutation PaymentGatewayToCreatePlan($input: paymentGatewayToCreatePlanMutationInput) {
    paymentGatewayToCreatePlan(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_PLAN_FOR_BG_ACCOUNT = gql`
  mutation CreatePlanForBgAccount($input: createPackageForBgAccountInput) {
    createPlanForBgAccount(input: $input) {
      status
      message
      data
    }
  }
`
export const CREATE_TICKET = gql`
  mutation CreateTicket($input: CreateTicketInput!) {
    createTicket(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_PRIORITY = gql`
  mutation CreatePriority($input: createPriorityInput!) {
    createPriority(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_STATUS = gql`
  mutation CreateStatus($input: addStatusInput!) {
    createStatus(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_TYPE = gql`
  mutation CreateType($input: addTypeInput!) {
    createType(input: $input) {
      status
      message
      data
    }
  }
`

export const EDIT_TICKET = gql`
  mutation EditTicket($input: editTicketInput!) {
    editTicket(input: $input) {
      status
      message
      data
    }
  }
`

export const ASSIGN_TICKET = gql`
  mutation AssignTicket($input: TicketAssignmentInput!) {
    assignTicket(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_TICKET = gql`
  mutation UpdateTicket($input: UpdateTicketInput!) {
    updateTicket(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_AGENT = gql`
  mutation UpdateAgent($input: updateAgentInput!) {
    updateAgent(input: $input) {
      status
      message
      data
    }
  }
`

export const SAVE_EMAIL_CONFIGURATION = gql`
  mutation SaveEmailConfiguration($input: saveEmailConfigurationMutationInput) {
    saveEmailConfiguration(input: $input) {
      status
      message
      data
    }
  }
`

export const SHARE_FORM = gql`
  mutation ShareForm($input: shareFormInput!) {
    shareForm(input: $input) {
      message
    }
  }
`

export const BLOCK_USER = gql`
  mutation BlockUser($input: DeleteUserInput!) {
    blockUser(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_WHITE_LABEL = gql`
  mutation CreateWhiteLabeling($input: createWhiteLabelingInputType) {
    createWhiteLabeling(input: $input) {
      id
      bgAccountId
      logo
      copyright
      companyName
    }
  }
`

export const UPDATE_WHITE_LABEL = gql`
  mutation UpdateWhiteLabeling($input: updateWhiteLabelingInputType) {
    updateWhiteLabeling(input: $input) {
      status
      message
      data
    }
  }
`

export const CREATE_NEW_MODULE = gql`
  mutation CreateNewModule($input: createNewModuleInput!) {
    createNewModule(input: $input) {
      status
      message
      data
    }
  }
`

export const ASSIGN_MODULE_TO_ROLE = gql`
  mutation AssignModuleToRole($input: assignModuleToRoleInput!) {
    assignModuleToRole(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_MODULE_ACCESS_FOR_ROLE = gql`
  mutation UpdateModuleAccessForRole($input: updateModuleAccessForRoleInput!) {
    updateModuleAccessForRole(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_API_URL = gql`
  mutation UpdateApiURL($input: addApiURL!) {
    updateApiURL(input: $input) {
      status
      message
      data
    }
  }
`

export const REMOVE_API_URL = gql`
  mutation RemoveApiURL($input: removeApiURL!) {
    removeApiURL(input: $input) {
      status
      message
      data
    }
  }
`

export const PACKAGE_EXPIRY_MAIL = gql`
  mutation PackageExpiryMail($input: sendPackageExpiryMailInput) {
    packageExpiryMail(input: $input) {
      status
      message
      data
    }
  }
`

export const UPDATE_MODULE_NAME = gql`
  mutation UpdateModuleName($input: updateModuleNameInput!) {
    updateModuleName(input: $input) {
      status
      message
      data
    }
  }
`

export const ADD_MAP = gql`
  mutation AddMaps($input: addMapsInput!) {
    addMaps(input: $input) {
      status
      message
      data
    }
  }
`

export const SAVE_TEAM_CONFIGURATION = gql`
  mutation SaveTeamsConfiguration($input: saveTeamsConfigurationMutationInput) {
    saveTeamsConfiguration(input: $input) {
      status
      message
      data
    }
  }
`

export const GOOGLE_MEET_CONFIGURATION = gql`
  mutation SaveGoogleMeetConfiguration($input: saveGoogleMeetConfigurationInput) {
    saveGoogleMeetConfiguration(input: $input) {
      status
      message
      data
    }
  }
`

export const SAVE_PAYPAL_PAYMENT_CONFIG = gql`
  mutation AddPaypalPaymentConfig($input: PaypalPaymentConfigInput!) {
    AddPaypalPaymentConfig(input: $input) {
      status
      message
      data
    }
  }
`

export const SAVE_RAZORPAY_PAYMENT_CONFIG = gql`
  mutation AddRazorPayPaymentConfig($input: RazorpayCredentialsInput!) {
    addRazorPayPaymentConfig(input: $input) {
      status
      message
      data
    }
  }
`

export const TRANSLATE_JSON = gql`
  mutation TranslateJson($input: translateJsonInput!) {
    translateJson(input: $input) {
      status
      message
      data
    }
  }
`

export const ADD_FORM_DEPENDENCY = gql`
  mutation AddFormDependency($input: AddFormDependencyMutation!) {
    AddFormDependency(input: $input) {
      message
      formUuid
    }
  }
`

export const IMPORT_PREFILL_RECIPIENTS = gql`
  mutation ImportPrefillRecipients($input: ImportPrefillRecipientsInput!) {
    importPrefillRecipients(input: $input) {
      batchUuid
      imported
      skipped
      errors
      warnings
      message
    }
  }
`

export const REVIEW_PREFILL_SUBMISSION_EDITS = gql`
  mutation ReviewPrefillSubmissionEdits($input: ReviewPrefillSubmissionEditsInput!) {
    reviewPrefillSubmissionEdits(input: $input) {
      success
      message
      reviewed
    }
  }
`

export const REVOKE_PREFILL_RECIPIENT = gql`
  mutation RevokePrefillRecipient($input: RevokePrefillRecipientInput!) {
    revokePrefillRecipient(input: $input) {
      success
      message
    }
  }
`

export const DELETE_PREFILL_RECIPIENT = gql`
  mutation DeletePrefillRecipient($input: DeletePrefillRecipientInput!) {
    deletePrefillRecipient(input: $input) {
      success
      message
    }
  }
`

export const SEND_PREFILL_LINKS = gql`
  mutation SendPrefillLinks($input: SendPrefillLinksInput!) {
    sendPrefillLinks(input: $input) {
      success
      message
      queued
      sent
      failed
    }
  }
`

export const RESEND_PREFILL_LINK = gql`
  mutation ResendPrefillLink($input: ResendPrefillLinkInput!) {
    resendPrefillLink(input: $input) {
      success
      message
      queued
      sent
      failed
    }
  }
`

export const SAVE_USER_EMAIL_SIGNATURE = gql`
  mutation SaveUserEmailSignature($input: SaveUserEmailSignatureInput!) {
    saveUserEmailSignature(input: $input) {
      hasSignature
      signatureHtml
      message
    }
  }
`
